export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-2.d57021c4.png";